const component = {
  template: `
    <div class="directory" id="directory">
      <div class="directory__wrapper">
        <div class="directory__header">
          <h2 ng-if="$ctrl.title"><span>{{$ctrl.title}}</span></h2>
          <p class="directory__caption" ng-if="$ctrl.caption" ng-bind-html="$ctrl.caption">test</p>
        </div>
        <div class="directory__items">
          <div class="directory__item" ng-repeat="item in $ctrl.item | orderBy: 'name'">
            <div class="item__wrapper">
              <div class="item__img" ng-if="item.image" style="background-image:url({{item.image}})"></div>
              <div class="item__details">
                <h4 ng-if="item.name"><span ng-bind-html="item.name"></span></h4>
                <h5 ng-if="item.email"><a href="mailto:{{item.email}}" ng-bind-html="item.email"></a></h5>
                <h5 ng-if="item.phone"><a href="tel:{{item.phone}}" ng-bind-html="item.phone"></a></h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
    title: '@',
    caption: '@',
    searchTitle: '@',
    items: '@'
  },
  controller() {
    this.$onInit = () => {
      this.item = JSON.parse(decodeURIComponent(this.items));
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/directory/index.js